import React from 'react';
import { SportType } from '../types/event';

interface SportsIconProps {
  sport: SportType;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

const SportsIcon: React.FC<SportsIconProps> = ({ 
  sport, 
  size = 24, 
  className = '', 
  style = {} 
}) => {
  const getSvgPath: (sportType: SportType) => string = (sportType: SportType): string => {
    // Map sport types to their corresponding SVG file names
    const sportFileMap: { [key in SportType]: string } = {
      'Tennis': 'tennis.svg',
      'Badminton': 'badminton.svg',
      'Golf': 'golf.svg',
      'Bouldering': 'bouldering.svg',
      'Pickleball': 'pickleball.svg',
      'Gym': 'gym.svg',
      'Hiking': 'hiking.svg',
      'Ski/Snowboarding': 'ski-snowboarding.svg'
    };
    
    const fileName = sportFileMap[sportType];
    if (!fileName) {
      console.warn(`Unknown sport type: ${sportType}, falling back to default`);
      return '/assets/icons/sports/tennis.svg'; // Fallback to a default icon
    }
    
    return `/assets/icons/sports/${fileName}`;
  };

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    // Fallback to emoji if SVG fails to load
    const target = e.target as HTMLImageElement;
    const fallbackEmojis: { [key in SportType]: string } = {
      'Tennis': '🎾',
      'Badminton': '🏸',
      'Golf': '⛳',
      'Bouldering': '🧗‍♂️',
      'Pickleball': '🏓',
      'Gym': '💪',
      'Hiking': '🥾',
      'Ski/Snowboarding': '⛷️'
    };
    
    // Replace the img with a span containing the emoji
    const parent = target.parentElement;
    if (parent) {
      const span = document.createElement('span');
      span.textContent = fallbackEmojis[sport];
      span.style.fontSize = `${size * 0.8}px`;
      span.style.display = 'flex';
      span.style.alignItems = 'center';
      span.style.justifyContent = 'center';
      span.className = className;
      Object.assign(span.style, style);
      parent.replaceChild(span, target);
    }
  };

  return (
    <img
      src={getSvgPath(sport)}
      alt={`${sport} icon`}
      width={size}
      height={size}
      className={className}
      style={{
        display: 'block',
        ...style
      }}
      onError={handleImageError}
    />
  );
};

export default SportsIcon;
